export const AUTH_COOKIE = "auth";
export const IS_SECURED_COOKIE = "is-secured";
export const CART = "cart";
export const REFRESH_AUTH_COOKIE = "refreshTokenAuth";
export const REFERRER = "referrer";
export const CUSTOMER = "customer";
